import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import LogoStrip from "../components/LogoStrip";
import Stats from "../components/Stats";
import About from "../components/About";
import Problems from "../components/Problems";
import HowItWorks from "../components/HowItWorks";
import Solutions from "../components/Solutions";
import WhyUs from "../components/WhyUs";
import Testimonials from "../components/Testimonials";
import EarlyAccess from "../components/EarlyAccess";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Home() {
    return (
        <div data-testid="home-page" className="bg-[#0A0A0E] text-zinc-100 min-h-screen">
            <Navbar />
            <main>
                <Hero />
                <LogoStrip />
                <Stats />
                <About />
                <Problems />
                <HowItWorks />
                <Solutions />
                <WhyUs />
                <Testimonials />
                <EarlyAccess />
                <FAQ />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}
